import { createContext, useContext, useEffect, useState } from "react";
import { STR } from "./i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("pdl-lang") || "fr");

  useEffect(() => {
    localStorage.setItem("pdl-lang", lang);
    document.documentElement.lang = lang;
    document.title =
      lang === "en"
        ? "Porte de Lumière — Holistic quantum & energy therapies"
        : "Porte de Lumière — Thérapies quantiques holistiques & énergétiques";
  }, [lang]);

  const s = STR[lang] || STR.fr;
  return <LanguageContext.Provider value={{ lang, setLang, s }}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);

export const LangToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div data-testid="lang-toggle" className={`flex items-center rounded-full border border-white/10 bg-white/[0.05] p-1 ${className}`}>
      {["fr", "en"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          type="button"
          onClick={() => setLang(l)}
          aria-label={l === "fr" ? "Français" : "English"}
          className={`rounded-full px-2.5 py-1 font-mono text-[11px] uppercase tracking-wider transition-colors duration-200 ${
            lang === l ? "bg-gold/25 text-gold-light" : "text-white/50 hover:text-white"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};
